export default __webpack_public_path__ + "static/media/David.5253e9d8.mp4";